import GamesDescriptor from './GamesDescriptor.jsx';

import './Games.css';

const Games = () => (
  <div id="Games">
		<h2>Games</h2>
    <a href="https://cafesoftie.itch.io/">My itch.io page</a>
    <div>
      <GamesDescriptor label="Sophie's Playground" screenshots={[]}>
        This is my current playground for game ideas.
        I have a screens system where I can easily switch between different screens.
        Essentially this means I can have different games and switch between them.
        Partially this is inspired by Final Fantasy games where they have mini-games inside the game.
        I recently re-played FF-7 and it's sorta crazy the different games they shoved into it, like snowboarding.
        Currently the screens are: area active turn based combat, and row turn based combat.
      </GamesDescriptor>
      <GamesDescriptor
        label="One Of Us Can Do It"
        screenshots={["game/oneofuscandoit/screenshot1.png"]}
        code="https://github.com/funkjunky/one-of-us-can-do-it"
        playLink="https://cafesoftie.itch.io/surely-one-of-us-can-do-it">
        This was for the 2025 GMTK gamejam. The theme was loop.
        I did it solo, using javascript and canvas2D, from scratch.
        The idea is you have 10 seconds to get to the goal... which is impossible.
        But when you try again, a ghost of your previous run also runs and you can use that to get to the goal.
        Admittedly, I didn't find enough time to do much polish, so it's very rough and only has a rudementary first level.
      </GamesDescriptor>
      <GamesDescriptor
        label="Minesweeper"
        screenshots={[]}
        Code="https://github.com/funkjunky/minesweeper"
        playLink="https://funkjunky.github.io/minesweeper/">
        After recovering from surgery and being unable to sit to program for a few months I was itching to challenge myself programming. I wanted to see how fast I could make minesweeper, considering it's a very predictable game that I know well. I believe I made the rough game in a couple hours, then it took about 3 days of working a couple hours each day to finish it up. The git commit comments would reveal more about that.
      </GamesDescriptor>
      <GamesDescriptor
        label="Text Battler"
        screenshots={[]}
        Code="https://github.com/funkjunky/text-battler">
        I wanted to quickly hash out a clone of the text based online game I played as a kid called "High Descent"
        It was fairly simply to do the combat. I stopped there. I'd love to revisit this and expand it more like the game I played.
        Like with shops, and daily battle limits and leveling up, etc.
      </GamesDescriptor>
      <GamesDescriptor
        label="phD in 8 years"
        screenshots={[]}
        Code="https://github.com/funkjunky/phd-in-8-years"
        playLink="https://funkjunky.github.io/phd-in-8-years">
        This was a gift I made for my partner at the time, who had just graduated with her phD.
        It's a platformer where you have to collect various things, then traverse a challenging platforming section to reach the phD at the top corner of the map.
      </GamesDescriptor>
      <GamesDescriptor
        label="SimTrump"
        screenshots={[]}
        Code="https://github.com/funkjunky/simtrump"
        playLink="https://funkjunky.github.io/simtrump/">
        I made this for the 2nd Peterborough Gamejam in 2017. It was shortly after Trump was elected for the first time.
        You play as Trump making decisions on how to react to the news. The controls use the arrow keys and it's a very simple game.
        Also it was the first and only time I ever used React to make a video game. I used a library called pixi-react, so also using the pixi js graphics engine.
      </GamesDescriptor>
      <GamesDescriptor
        label="Aster Redux <TODO: get it working again in github.io!!>"
        screenshots={[]}
        Code="https://github.com/funkjunky/reduxgame"
        playLink="https://funkjunky.github.io/reduxgame/">
        I made this asteroids clone to see what making a game using redux would be like.
        More specifically, taking redux to the extreme. I think I alsohad reducers feeding into reducers in the game loop.
        It was a bit silly as a programming experience. The readme includes a bit of a journal of my process! 🤔 I should do that more often...
      </GamesDescriptor>
      <GamesDescriptor
        label="AI Army"
        screenshots={[]}
        Code="https://github.com/funkjunky/aiarmy"
        playLink="https://funkjunky.github.io/aiarmy">
        Tried making an isometric auto battler. First time using cocos2d and I did not enjoy using it.
        Eventually my frustration caused me to stop working on the project. I got a battle working, but then stopped.
      </GamesDescriptor>
      <GamesDescriptor
        label="Ball and Wall <TODO: re-up>"
        screenshots={[]}
        Code="https://github.com/funkjunky/Ball-and-Wall"
        playLink="https://funkjunky.github.io/Ball-and-Wall">
        This was a creation of a game I enjoyed when i was a young child where you would balls would be bouncing around a box, and you had to click to create walls that would isolate space with no balls and if a ball hit a wall while it was forming, you lost.
        I vaguely remember playing with abstracting many game engine systems for this game.
        There's no index.js so im not sure where the code start, lol.
      </GamesDescriptor>
      <GamesDescriptor
        label="AI Army"
        screenshots={[]}
        Code="https://github.com/funkjunky/aiarmy"
        playLink="https://funkjunky.github.io/aiarmy">
      </GamesDescriptor>
      <GamesDescriptor
        label="Ball and Wall <TODO: get it working again in github.io"
        screenshots={[]}
        Code="https://github.com/funkjunky/Ball-and-Wall"
        playLink="https://funkjunky.github.io/Ball-and-Wall">
      </GamesDescriptor>
    </div>
  </div>
);

export default Games;
